import { createGlobalStyle } from 'styled-components/macro';
import { remSizes, BREAKPOINTS } from './constants.style';

const calcRemInPercentage = (remSize: number) => `${((remSize * 10) / 16) * 100}%`;

export const ResponsiveRem = createGlobalStyle`
    :root {
        @media only screen and (min-width: 1260px) {
            font-size: ${calcRemInPercentage(remSizes.small)};
        }
        @media only screen and (min-width: ${BREAKPOINTS.xl}px) {
            font-size: ${calcRemInPercentage(remSizes.medium)};
        }
        @media only screen and (min-width: ${BREAKPOINTS.xxl}px) {
            font-size: ${calcRemInPercentage(remSizes.large)};
        }
    }
`;

export const rem = (num: number) => num / 10;
